import { GET_ROLL_NUMBER } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface getRollNumberState extends BaseAsyncReducerState {
    rollNumDetail?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: getRollNumberState  = {
    loading: false,
    error: false
}


function getRollNumberReducer(state = initialState, action: AppAction | AppNoApiAction) {
        // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_ROLL_NUMBER.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_ROLL_NUMBER.SUCCESS:
            return {
                ...state,
                rollNumDetail: payload,
                loading: false,
                error: false

            }
        case GET_ROLL_NUMBER.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state
        }
        
}

export default getRollNumberReducer;